function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  x: "0",
  y: "0",
  viewBox: "0 0 463 463",
  width: "40",
  height: "40",
  xmlSpace: "preserve",
  id: "svg14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "path229",
  d: "M140.765 326.629a170.254 125.617 0 01-46.576-163.637 170.254 125.617 0 01215.02-52.813 170.254 125.617 0 0195.65 151.583 170.254 125.617 0 01-193.19 87.409",
  fill: "#fff",
  fillOpacity: "0",
  stroke: "#000",
  strokeWidth: "12.639",
  strokeOpacity: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.118 324.587c13.853 7.69 27.69 15.37 28.442 25.515.752 10.144-11.568 22.759-23.888 35.373",
  id: "path2117",
  fill: "#fff",
  fillOpacity: "0",
  stroke: "#000",
  strokeWidth: "12.639",
  strokeOpacity: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.458 347.977c-11.455 11.729-22.91 23.457-35.916 29.556-13.006 6.099-27.576 6.569-42.158 7.039",
  id: "path2121",
  fill: "#fff",
  fillOpacity: "0",
  stroke: "#000",
  strokeWidth: "12.639",
  strokeOpacity: "1"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path3001",
  cx: "178.256",
  cy: "235.51",
  rx: "21.411",
  ry: "18.37",
  fill: "#fff",
  fillOpacity: "0",
  stroke: "#000",
  strokeWidth: "11.575",
  strokeOpacity: "1"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path3001-3",
  cx: "243.347",
  cy: "234.633",
  rx: "21.411",
  ry: "18.37",
  fill: "#fff",
  fillOpacity: "0",
  stroke: "#000",
  strokeWidth: "11.575",
  strokeOpacity: "1"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path3001-6",
  cx: "305.24",
  cy: "234.675",
  rx: "21.411",
  ry: "18.37",
  fill: "#fff",
  fillOpacity: "0",
  stroke: "#000",
  strokeWidth: "11.575",
  strokeOpacity: "1"
})));